import { RasterBoolCatComponentProperties } from "../components/raster_bool_cat_component"

export const IndonesiaForestLossProperties: RasterBoolCatComponentProperties = {
    name: 'Indonesia Forest Loss Drivers',
    sources: [
        {name: 'Indonesia Forest Loss', source: 'ind:drivers_forest_loss_1km_2001_2024_v1_2'}
    ],
    options: [
        {label: 'Permanent agriculture', value: 1},
        {label: 'Hard commodities', value: 2},
        {label: 'Shifting cultivation', value: 3},
        {label: 'Logging', value: 4},
        {label: 'Wildfire', value: 5},
        {label: 'Settlements and infrastructure', value: 6},
        {label: 'Other natural disturbances', value: 7}
    ]
}

export const IndonesiaForestLossYearProperties: RasterBoolCatComponentProperties = {
    name: 'Indonesia Forest Loss by Year',
    sources: [
        {name: 'Indonesia Forest Loss', source: 'ind:Hansen_GFC-2024-v1.12_lossyear_10N_120E'}
    ],
    options: [
        {label: '2001', value: 1},
        {label: '2002', value: 2},
        {label: '2003', value: 3},
        {label: '2004', value: 4},
        {label: '2005', value: 5},
        {label: '2006', value: 6},
        {label: '2007', value: 7},
        {label: '2008', value: 8},
        {label: '2009', value: 9},
        {label: '2010', value: 10},
        {label: '2011', value: 11},
        {label: '2012', value: 12},
        {label: '2013', value: 13},
        {label: '2014', value: 14},
        {label: '2015', value: 15},
        {label: '2016', value: 16},
        {label: '2017', value: 17},
        {label: '2018', value: 18},
        {label: '2019', value: 19},
        {label: '2020', value: 20},
        {label: '2021', value: 21},
        {label: '2022', value: 22},
        {label: '2023', value: 23},
        {label: '2024', value: 24}
    ]
}